import { render, staticRenderFns } from "./SalesAmountRank.vue?vue&type=template&id=25050dc4&scoped=true&"
import script from "./SalesAmountRank.vue?vue&type=script&lang=js&"
export * from "./SalesAmountRank.vue?vue&type=script&lang=js&"
import style0 from "./SalesAmountRank.vue?vue&type=style&index=0&id=25050dc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25050dc4",
  null
  
)

export default component.exports